<template>
  <div class="margin-subpages" id="power_skill_page">
    <el-select
      v-model="selectTeam"
      filterable
      placeholder="Select"
      class="input-style"
      @change="handleTeams"
      :class="[ blurMode ?  'blurelement': '' ]"
    >
      <el-option
        v-if="user.user_type !== 'leadership'"
        class="text-dropdown"
        key="all"
        :label="`All Teams (${$utils(
          'addCommasInNumber',
          optionsTeam.length
        )})`"
        value="all"
      ></el-option>
      <el-option
        class="text-dropdown"
        v-for="item in optionsTeam"
        :key="item.key"
        :label="item.name"
        :value="item.key"
        :class="[ blurMode ?  'blurelement': '' ]"
      ></el-option>
    </el-select>
    <div id="byManager">
      <div class="mt-30 fs-18 fw-700">Power Skills Progress & Ratings</div>
      <div class="fc-747474 fs-13 mt-6">
        The overall effort score for practicing each skill with a rating trend and leaderboard from the past 6-months
      </div>
    </div>
    <div class="mt-32"></div>
    
    <!-- Loading State -->
    <div v-if="loading || isLoading" class="loading-container">
      <div class="loading-content">
        <div class="main-loading-spinner"></div>
        <p class="loading-text">Loading Power Skills data...</p>
      </div>
    </div>
    
    <!-- Error State -->
    <div v-else-if="hasError" class="error-container">
      <div class="error-content">
        <h3>Unable to load Power Skills data</h3>
        <p>{{ errorMessage }}</p>
        <button @click="retryLoading" class="retry-button">Retry</button>
      </div>
    </div>
    
    <!-- Empty State -->
    <div v-else-if="!pageData || pageData.length === 0" class="empty-container">
      <div class="empty-content">
        <h3>No Power Skills data available</h3>
        <p>There's no data to display for the selected criteria.</p>
      </div>
    </div>
    
    <!-- Main Content -->
    <el-collapse v-else v-model="activeName">
      <el-collapse-item
        v-for="(skill, index) in pageData"
        :key="index + '_' + skill.title"
        :name="skill.title"
      >
        <template slot="title">
          <div class="relative flex-cemter title-custom">
            <div
              class="score-bar"
              :style="`background: ${skill.primaryColor}; width: ${skill.score}%;}`"
            ></div>
            <div class="flex-center ml-18 mr-14" style="z-index: 2">
              <img
                :class="`${
                  activeName.includes(skill.title) ? 'rolate' : ''
                } image-expand`"
                :src="$utils('icons', 'ic_expand_24dp')"
                alt="icons_ic_expand_24dp"
              />
            </div>
            <div v-if="skill.title" class="relative" style="width: 48px">
              <img
                class="icon absolute-mid"
                :src="getImgIconOfPower(skill.title)"
                :alt="skill.title"
              />
            </div>
            <div class="label fw-700 ml-4 mr-auto">{{ skill.title }}</div>
            <div class="label ml-auto mr-15">{{ skill.score }}%</div>
          </div>
        </template>
        <div class="fs-16 skill-body">
          <div
            class="chart-container"
            :style="`background: ${skill.primaryColor}0A;`"
          >
            <div class="flex-center chart-title">
              <div
                class="box-color"
                :style="`background: ${skill.primaryColor};`"
              ></div>
              {{ selectTeam == "all" ? "All Teams" : (teamsAll[selectTeam] ? teamsAll[selectTeam].name : "Team") }}
              <div
                v-if="selectTeam !== 'all'"
                class="box-color ml-16"
                :style="`background: ${skill.secondaryColor};`"
              ></div>
              <span v-if="selectTeam !== 'all'">Company Avg.</span>
            </div>
            <div>
              <div class="bar-chart-conainter-style ">
                <div class="relative" style="z-index: 99; height: 134px">
                  <div v-if="isChartsLoading" class="chart-loading">
                    <div class="loading-spinner"></div>
                  </div>
                  <canvas
                    :ref="skill.title + '_bar_chart'"
                    height="120px"
                    class="barchart-style"
                    :style="{ opacity: isChartsLoading ? 0.3 : 1 }"
                  ></canvas>
                </div>
                <div class="line-dashed"></div>
              </div>
              <div
                :style="`height: 170px; border-radius: 6px; background: ${skill.primaryColor}0A; padding: 24px 54px; position: relative;`"
              >
                <div class="percentile-legend">
                  <span class="legend-item">
                    <span class="legend-line" :style="`border-color: ${skill.primaryColor}; border-style: dashed;`"></span>
                    75th
                  </span>
                  <span class="legend-item">
                    <span class="legend-line" :style="`border-color: ${skill.primaryColor}; border-style: solid; border-width: 2px;`"></span>
                    Median
                  </span>
                  <span class="legend-item">
                    <span class="legend-line" :style="`border-color: ${skill.primaryColor}; border-style: dotted;`"></span>
                    25th
                  </span>
                </div>
                <canvas
                  :ref="skill.title + '_line_chart'"
                  height="150px"
                  class="linechart-style"
                ></canvas>
              </div>
            </div>
          </div>
          <div class="flex-center mt-16 mb-12">
            <div class="fs-14 fw-700" :style="`color: ${skill.primaryColor};`">
              LEADERBOARD
            </div>
            <div class="ml-auto flex-center">
              <div class="fs-14 mr-16">Sort by</div>
              <div style="width: 220px">
                <el-menu class="input-select" mode="horizontal">
                  <el-submenu index="0" style="width: 220px">
                    <template slot="title">
                      <span class="text-dropdown">
                        {{ selectSort ? selectSort : "All" }}
                      </span>
                    </template>
                    <el-menu-item
                      @click="sortingClick('Ascending Rating',index)"
                      index="1"
                      style="font-size: 14px; width: 220px"
                      >Ascending Rating</el-menu-item
                    >
                    <el-menu-item
                      @click="sortingClick('Ascending Score',index)"
                      index="1"
                      style="font-size: 14px; width: 220px"
                      >Ascending Score</el-menu-item
                    >
                    <el-menu-item
                      @click="sortingClick('Descending Rating',index)"
                      index="1"
                      style="font-size: 14px; width: 220px"
                      >Descending Rating</el-menu-item
                    >
                    <el-menu-item
                      @click="sortingClick('Descending Score',index)"
                      index="1"
                      style="font-size: 14px; width: 220px"
                      >Descending Score</el-menu-item
                    >
                  </el-submenu>
                </el-menu>
              </div>
            </div>
          </div>
          <div class="leaderboard-conainter">
            <div
              v-for="(member, i2) in reranderArrayForShowing(
                skill.Leaderboards
              )"
              :key="i2 + '_profile_' + skill.title"
              class="member-card flex-center relative"
            >
              <div class="index">{{ member.index + 1 }}</div>
              <div v-if="member.imageProfile">
                <img
                  v-lazy="member.imageProfile"
                  :key="member.imageProfile"
                  class="image-skeleton image-profile-32"
                  :class="[ blurMode ?  'blurelement': '' ]"
                />
              </div>
              <div v-else class="image image-profile-32"
              :class="[ blurMode ?  'blurelement': '' ]">
                <div class="text-in-image text-in-image-42 flex-mid">
                  {{
                    $utils("acronymName", {
                      fullName: member.name,
                    })
                  }}
                </div>
              </div>
              <div class="label-member">
                <div class="name ellipsis"
                :class="[ blurMode ?  'blurelement': '' ]">{{ member.name }}</div>
                <div class="team-name ellipsis"
                :class="[ blurMode ?  'blurelement': '' ]">{{ member.teamname }}</div>
              </div>
              <div class="scorenum-label" :style="`color: ${skill.primaryColor};`">
                {{ $utils("addCommasInNumber", member.score) }}
              </div>
              <div class="rate-label ml-auto mr-4">{{ member.rating }}</div>
              <div class="flex-mid">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  id="star_black_24dp"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  class="pb-2"
                >
                  <g id="Group_13402" data-name="Group 13402">
                    <path
                      id="Path_5306"
                      data-name="Path 5306"
                      d="M0,0H16V16H0Z"
                      fill="none"
                    />
                    <path
                      id="Path_5307"
                      data-name="Path 5307"
                      d="M0,0H16V16H0Z"
                      fill="none"
                    />
                  </g>
                  <g
                    id="Group_13403"
                    data-name="Group 13403"
                    transform="translate(2.295 2.382)"
                    :fill="skill.primaryColor"
                  >
                    <path
                      id="Path_5308"
                      data-name="Path 5308"
                      d="M9.148,12.7l2.767,1.673a.665.665,0,0,0,.993-.72l-.733-3.147,2.447-2.12a.665.665,0,0,0-.38-1.167l-3.22-.273L9.761,3.978a.667.667,0,0,0-1.227,0L7.274,6.944l-3.22.273a.665.665,0,0,0-.38,1.167L6.121,10.5l-.733,3.147a.665.665,0,0,0,.993.72Z"
                      transform="translate(-3.443 -3.573)"
                    />
                  </g>
                </svg>
              </div>
              <div
                class="rating-bar"
                :style="`background: ${skill.primaryColor}; width: ${member.bar}%;`"
              ></div>
            </div>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import Chart from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";

export default {
  name: "power-skills",
  components: {
    loadingEven: require("../even/loading").default,
  },
  async created() {
    try {
      console.log('Power Skills component created, loading initial data...');
      this.isLoading = true;
      await Promise.all([
        this.$store.dispatch("team/getTeamsOptionsFixed", this.user),
        this.$store.dispatch("powerSkill/getOrganization1level")
      ]);
      console.log('Power Skills initial data loading completed');
      
      // Check if we need to manually trigger data loading
      console.log('Current pageData:', this.pageData);
      if ((!this.pageData || this.pageData.length === 0) && !this.dataLoadingInitiated && !this.loading) {
        console.log('No pageData found, triggering manual data fetch...');
        this.dataLoadingInitiated = true;
        const teamId = this.user.user_type === "leadership" ? this.user.team : "all";
        await this.$store.dispatch("powerSkill/getData", teamId);
      }
    } catch (error) {
      console.error('Error loading initial data:', error);
      this.hasError = true;
      this.errorMessage = 'Failed to load initial data';
      this.isLoading = false;
    }
  },

  watch: {
    optionsTeam() {
      console.log('optionsTeam watcher triggered, length:', this.optionsTeam.length);
      if (this.optionsTeam.length > 0 && this.selectTeam === "") {
        this.selectTeam =
          this.user.user_type == "leadership" ? this.user.team : "all";
        console.log('optionsTeam watcher set selectTeam to:', this.selectTeam);
        
        // Only trigger data loading if we haven't loaded data yet and aren't already loading
        if ((!this.pageData || this.pageData.length === 0) && !this.loading && !this.isLoading) {
          console.log('optionsTeam watcher triggering getData...');
          this.isLoading = true;
          this.$store.dispatch("powerSkill/getData", this.selectTeam);
        }
      }
    },
    selectTeam(newTeam, oldTeam) {
      if (newTeam !== oldTeam && newTeam !== "") {
        this.$store.dispatch("insightsManagers/setTeamSorting", newTeam);
      }
    },
    pageData: {
      handler(newData, oldData) {
        console.log('Power Skills pageData changed:', { 
          newData: newData ? newData.length : 0, 
          oldData: oldData ? oldData.length : 0 
        });
        try {
          this.hasError = false;
          this.errorMessage = "";
          
          if (newData && newData.length > 0) {
            console.log('Power Skills data loaded successfully');
            this.isLoading = false;
            this.destroyExistingCharts();
            this.$nextTick(() => {
              this.renderChartsAsync();
              if (newData[0] && newData[0].title && !this.activeName.includes(newData[0].title)) {
                this.activeName.push(newData[0].title);
              }
            });
          } else if (oldData === undefined) {
            // Still loading initial data
            console.log('Power Skills still loading initial data');
            this.isLoading = true;
          } else {
            // Data loaded but empty
            console.log('Power Skills data loaded but empty');
            this.isLoading = false;
          }
        } catch (error) {
          console.error('Error handling pageData change:', error);
          this.hasError = true;
          this.errorMessage = 'Failed to process Power Skills data';
          this.isLoading = false;
        }
      },
      immediate: false
    },
  },
  computed: {
    user() {
      return this.$store.getters["authen/user"];
    },
    optionsTeam() {
      return this.$store.getters["team/teamsfixedall"];
    },
    pageData () {
      
      return this.$store.getters["powerSkill/pageData"];
    },
    teamsAll(){
      return this.$store.getters["powerSkill/teamsAll"];
    },
    blurMode() {
      return this.$store.getters["demomode/blurMode"];
    },
    loading() {
      return this.$store.getters["powerSkill/loading"];
    },
   
  },
  data() {
    return {
      selectTeam: "",
      activeName: [""],
      mappingData: [
        {
          title: "Empathy",
          icon: "ic_empathy",
          primaryColor: "#6000DA",
          secondaryColor: "#C8B0E6",
        },
        {
          title: "Self Awareness",
          icon: "ic_selfawareness",
          primaryColor: "#f77511",
          secondaryColor: "#FFD3B1",
        },
        {
          title: "Critical Thinking",
          icon: "ic_criticalthinking",
          primaryColor: "#ff2b19",
          secondaryColor: "#FFCCC7",
        },
        {
          title: "Leadership",
          icon: "ic_leadership",
          primaryColor: "#00AA1A",
          secondaryColor: "#CBFFD3",
        },
        {
          title: "Initiative Making",
          icon: "ic_initiative",
          primaryColor: "#8CE100",
          secondaryColor: "#DBFCA5",
        },
        {
          title: "Optimism",
          icon: "ic_optimism",
          primaryColor: "#F2D222",
          secondaryColor: "#F8E88B",
        },
      
      ],
      myChart:{
        ps_critical_thinking:'',
        ps_empathy:'',
        ps_initiative_making:'',
        ps_leadership:'',
        ps_optimism:'',
        ps_self_awareness:''
      },
      lineChart:{
        ps_critical_thinking:'',
        ps_empathy:'',
        ps_initiative_making:'',
        ps_leadership:'',
        ps_optimism:'',
        ps_self_awareness:''
      },
      selectSort: "Descending Score",
      isChartsLoading: false,
      isLoading: true,
      hasError: false,
      errorMessage: "",
      dataLoadingInitiated: false,
    };
  },
  mounted() {
    console.log('Power Skills component mounted');
    console.log('Options team length:', this.optionsTeam.length);
    console.log('Current selectTeam:', this.selectTeam);
    console.log('User type:', this.user.user_type);
    
    if (this.optionsTeam.length > 0 && this.selectTeam == "" && !this.dataLoadingInitiated) {
      this.selectTeam =
        this.user.user_type == "leadership" ? this.user.team : "all";
      console.log('Set selectTeam to:', this.selectTeam);
      this.dataLoadingInitiated = true;
    }
    
    // Set a timeout to handle cases where data doesn't load
    setTimeout(() => {
      if ((this.loading || this.isLoading) && !this.hasError) {
        console.log('Data loading timeout reached');
        this.hasError = true;
        this.errorMessage = 'Data loading is taking longer than expected. Please try refreshing the page.';
        this.isLoading = false;
      }
    }, 15000); // 15 second timeout
    
    this.$nextTick(() => {
      console.log('Power Skills nextTick - pageData length:', this.pageData ? this.pageData.length : 0);
      if (this.pageData && this.pageData.length > 0) {
        this.isLoading = false;
        this.renderChartsAsync();
        if (this.pageData[0] && this.pageData[0].title) {
          this.activeName.push(this.pageData[0].title);
        }
      }
    });
  },
  beforeDestroy() {
    this.destroyExistingCharts();
  },
  methods: {
    // Optimized chart destruction
    destroyExistingCharts() {
      const chartIds = ['ps_critical_thinking', 'ps_empathy', 'ps_initiative_making', 'ps_leadership', 'ps_optimism', 'ps_self_awareness'];
      
      chartIds.forEach(id => {
        if (this.myChart[id]) {
          this.myChart[id].destroy();
          this.myChart[id] = null;
        }
        if (this.lineChart[id]) {
          this.lineChart[id].destroy();
          this.lineChart[id] = null;
        }
      });
    },
    
    // Async chart rendering with requestAnimationFrame
    async renderChartsAsync() {
      if (!this.pageData || this.pageData.length === 0) return;
      
      this.isChartsLoading = true;
      
      // Render charts with small delays to prevent blocking
      for (let i = 0; i < this.pageData.length; i++) {
        await new Promise(resolve => {
          requestAnimationFrame(() => {
            this.randerBarChartItem(this.pageData[i]);
            this.randerLineChartItem(this.pageData[i]);
            resolve();
          });
        });
        
        // Small delay between charts to prevent UI blocking
        if (i < this.pageData.length - 1) {
          await new Promise(resolve => setTimeout(resolve, 50));
        }
      }
      
      this.isChartsLoading = false;
    },
    
    // Retry loading data
    async retryLoading() {
      try {
        this.isLoading = true;
        this.hasError = false;
        this.errorMessage = "";
        
        await Promise.all([
          this.$store.dispatch("team/getTeamsOptionsFixed", this.user),
          this.$store.dispatch("powerSkill/getOrganization1level")
        ]);
        
        // If still no data after retry, getData might need to be called
        if (!this.pageData || this.pageData.length === 0) {
          await this.$store.dispatch("powerSkill/getData", this.selectTeam || "all");
        }
      } catch (error) {
        console.error('Error during retry:', error);
        this.hasError = true;
        this.errorMessage = 'Failed to load data. Please check your connection and try again.';
        this.isLoading = false;
      }
    },
    handleTeams(key) {
      if (this.selectTeam !== key && !this.loading) {
        this.selectTeam = key;
        // console.log("Here handleTeams", key);
        this.$store.dispatch("powerSkill/getData", key);
      }
    },
    mappingDataFuc(name) {
      const data = this.mappingData.find((item) => item.title == name);
      return data || {};
    },
    getImgIconOfPower(name) {
      const data = this.mappingDataFuc(name);
      return require("@/assets/images/components/profile/" +
        data.icon +
        ".png");
    },
    reranderArrayForShowing(data) {
      const evenArr = [];
      const oddArr = [];

      // Split the array into even and odd elements
      for (let i = 0; i < data.length; i++) {
        const item = { index: i, ...data[i] };

        if (i % 2 === 0) {
          evenArr.push(item);
        } else {
          oddArr.push(item);
        }
      }

      // Combine the even and odd arrays in the desired pattern
      const result = [];
      const maxLength = Math.max(evenArr.length, oddArr.length);

      for (let i = 0; i < maxLength; i++) {
        if (i < evenArr.length) {
          result.push(evenArr[i]);
        }
        if (i < oddArr.length) {
          result.push(oddArr[i]);
        }
      }

      return result;
    },
    randerBarChartItem(item) {
      if (!item || !item.title || !item.barChartData) return;
      
      const barchart = this.$refs[item.title + "_bar_chart"];
      if (!barchart || !barchart[0]) return;
      
      // Destroy existing chart if it exists
      if (this.myChart[item.id] && typeof this.myChart[item.id].destroy === 'function') {
        this.myChart[item.id].destroy();
        this.myChart[item.id] = null;
      }
      
      try {
        
        // When "All Teams" is selected, only show company data (no comparison needed)
        // When specific team is selected, show both team data and company average
        const datasets = [];
        
        if (this.selectTeam === "all") {
          // Only show company-wide data when "All Teams" is selected
          datasets.push({
            label: item.barChartData.datasets[0].label,
            data: item.barChartData.datasets[0].data,
            backgroundColor: item.primaryColor,
            borderColor: item.primaryColor,
            borderWidth: 1,
          });
        } else {
          // Show both team data and company average for comparison
          datasets.push(
            {
              label: item.barChartData.datasets[1].label, // Company Avg
              data: item.barChartData.datasets[1].data,
              backgroundColor: item.secondaryColor,
              borderColor: item.secondaryColor,
              borderWidth: 1,
            },
            {
              label: item.barChartData.datasets[0].label, // Selected Team
              data: item.barChartData.datasets[0].data,
              backgroundColor: item.primaryColor,
              borderColor: item.primaryColor,
              borderWidth: 1,
            }
          );
        }
        
        const townHallChartData = {
          labels: item.barChartData.labels,
          datasets: datasets,
        };
        const options = {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: { display: false },
            tooltip: { enabled: false },
          },
          scales: {
            y: {
              display: false,
              beginAtZero: true,
            },
            x: {
              grid: { display: false },
              ticks: {
                maxRotation: 0,
                font: { size: 11, weight: '500' },
                color: '#666',
              },
            },
          },
          animation: { duration: 300 },
          elements: {
            bar: {
              borderRadius: 4,
              borderSkipped: false,
            },
          },
        };
        this.myChart[item.id] = new Chart(barchart[0].getContext("2d"), {
          type: "bar",
          data: townHallChartData,
          options: options,
        });
      } catch (error) {
        console.error('Error rendering bar chart:', error);
      }
    },
    randerLineChartItem(item) {
      if (!item || !item.title || !item.lineChartData) return;
      
      const barchart = this.$refs[item.title + "_line_chart"];
      if (!barchart || !barchart[0]) return;
      
      // Destroy existing chart if it exists
      if (this.lineChart[item.id] && typeof this.lineChart[item.id].destroy === 'function') {
        this.lineChart[item.id].destroy();
        this.lineChart[item.id] = null;
      }
      
      try {
        
        // Process multiple datasets for percentiles
        const datasets = item.lineChartData.datasets.map((dataset, index) => {
          // Replace zero values with null for cleaner visualization
          const dataPoints = [...dataset.data];
          for (let i = 0; i < dataPoints.length; i++) {
            if (dataPoints[i] === 0 || dataPoints[i] === undefined) {
              dataPoints[i] = null;
            }
          }
          
          return {
            label: dataset.label,
            data: dataPoints,
            backgroundColor: dataset.backgroundColor || item.primaryColor,
            borderColor: dataset.borderColor || item.primaryColor,
            borderDash: dataset.borderDash || [],
            borderWidth: dataset.label === "Median (50th)" ? 2 : 1, // Make median line thicker
            spanGaps: true, // Skip null data points when drawing the line
            fill: false,
            tension: 0.1, // Slight curve for smoother lines
          };
        });
        
        const townHallChartData = {
          labels: item.lineChartData.labels,
          datasets: datasets,
        };
        const options = {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: { display: false },
            tooltip: { 
              enabled: true,
              backgroundColor: 'rgba(0,0,0,0.8)',
              titleColor: '#fff',
              bodyColor: '#fff',
              borderColor: item.primaryColor,
              borderWidth: 1,
            },
          },
          scales: {
            y: {
              display: false,
              beginAtZero: true,
            },
            x: {
              display: false,
            },
          },
          layout: {
            padding: { left: 30, right: 10, top: 25, bottom: 5 },
          },
          animation: { duration: 400 },
          interaction: {
            intersect: false,
            mode: 'index',
          },
        };
        options.plugins.datalabels = {
          display: function(context) {
            // Only show labels for the median (50th percentile) line and valid data points
            if (context.dataset.label !== "Median (50th)") return false;
            if (!context.parsed || context.parsed.y === null || context.parsed.y === undefined) return false;
            return true;
          },
          color: item.primaryColor,
          font: {
            weight: "bold",
            size: 10,
          },
          anchor: "end",
          clamp: true,
          align: "top",
          offset: 2,
          formatter: function(value) {
            return value !== null && value !== undefined ? value : '';
          }
        };
        this.lineChart[item.id]= new Chart(barchart[0].getContext("2d"), {
          type: "line",
          data: townHallChartData,
          options: options,
          plugins: [ChartDataLabels],
        });
      } catch (error) {
        console.error('Error rendering line chart:', error);
      }
    },
    sortingClick(status,index) {
      // console.log("Here sortingClick", index)
      this.selectSort = status;
      this.$store.dispatch("powerSkill/sortData",{sort:status,index:index});
    },
  },
};
</script>

<style lang="scss" scoped>
.title-custom {
  display: flex;
  justify-content: space-between;
  color: #fff;
  width: 100%;

  .image-expand {
    width: 20px;
    height: 20px;
    transition: 0.3s;
    transform: rotate(0deg);
  }
  .image-expand.rolate {
    transform: rotate(180deg);
  }

  .score-bar {
    position: absolute;
    left: 0;
    border-radius: 6px;
    height: 100%;
    box-shadow: 0px 1px 6px #00000014;
  }

  .label {
    font-size: 14px;
    font-weight: 700;
    z-index: 2;
  }
}

.skill-body {
  .chart-container {
    position: relative;
    height: 366px;
    width: calc(100% - 40px);
    padding: 15px 20px 28px;
    margin-top: 4px;
    border-radius: 24px;

    .chart-title {
      font-size: 12px;
      font-weight: 700;

      .box-color {
        height: 16px;
        width: 16px;
        border-radius: 3px;
        margin-right: 8px;
      }
    }
  }
}

.leaderboard-conainter {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(5, 64px);
  gap: 6px 32px;
  padding-right: 20px;
  grid-auto-flow: column;
  list-style: none;

  .member-card {
    height: 64px;
    padding: 0 24px 0 16px;
    border: 1px solid #dddddd;
    border-width: 1px;
    border-radius: 6px;
    overflow: hidden;

    .index {
      color: #0000004d;
      font-size: 14px;
      font-weight: 700;
      width: 24px;
      padding-top: 2px;
    }

    .label-member {
      line-height: 16px;
      width: 190px;
      margin-left: 12px;
    }

    .name {
      color: #000;
      font-size: 14px;
      font-weight: 700;
    }

    .team-name {
      color: #000;
      font-size: 13px;
    }

    .scorenum-label {
      font-size: 16px;
      font-weight: 700;
      width: 66px;
      text-align: right;
      margin-right: 12px;
    }
    .rate-label {
      font-size: 16px;
      font-weight: 700;
    }
    .rating-bar {
      height: 4px;
      position: absolute;
      bottom: 0;
      left: 0;
    }
  }
}
.bar-chart-conainter-style {
  padding: 12px 24px;
  position: relative;
  .line-dashed {
    content: "";
    position: absolute;
    top: 48px;
    left: 24px;
    width: calc(100% - 48px);
    height: 36px;
    opacity: 0.5;
    border: 1px dashed #dddddd;
    border-width: 1px 0;
  }
}

.percentile-legend {
  position: absolute;
  top: 8px;
  right: 24px;
  display: flex;
  gap: 16px;
  font-size: 11px;
  font-weight: 600;
  z-index: 10;
  
  .legend-item {
    display: flex;
    align-items: center;
    gap: 4px;
    
    .legend-line {
      width: 20px;
      height: 0;
      border-top-width: 1px;
      display: inline-block;
    }
  }
}

.chart-loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 100;
}

.loading-spinner {
  width: 24px;
  height: 24px;
  border: 2px solid #f3f3f3;
  border-top: 2px solid #6c30cc;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

// Main loading state
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  padding: 40px;
}

.loading-content {
  text-align: center;
}

.main-loading-spinner {
  width: 48px;
  height: 48px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #6c30cc;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 16px;
}

.loading-text {
  font-size: 16px;
  color: #666;
  margin: 0;
}

// Error state
.error-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  padding: 40px;
}

.error-content {
  text-align: center;
  max-width: 400px;
  
  h3 {
    color: #e74c3c;
    margin-bottom: 12px;
    font-size: 18px;
  }
  
  p {
    color: #666;
    margin-bottom: 20px;
    line-height: 1.5;
  }
}

.retry-button {
  background-color: #6c30cc;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 12px 24px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
  
  &:hover {
    background-color: #5a2ba8;
  }
  
  &:active {
    background-color: #4e2496;
  }
}

// Empty state
.empty-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
  padding: 40px;
}

.empty-content {
  text-align: center;
  
  h3 {
    color: #666;
    margin-bottom: 12px;
    font-size: 18px;
  }
  
  p {
    color: #999;
    line-height: 1.5;
  }
}
</style>

<style lang="scss">
#power_skill_page {
  .el-collapse-item__header {
    background-color: #cccccc;
    border: 0;
    border-radius: 6px;
    box-shadow: 0px 1px 6px #00000014;
    margin-bottom: 12px;
  }

  .el-collapse-item__arrow {
    display: none;
  }

  .el-collapse,
  .el-collapse-item__wrap {
    border: 0;
  }
  
  .percentile-legend {
    position: absolute;
    top: 5px;
    right: 10px;
    font-size: 11px;
    display: flex;
    gap: 12px;
    z-index: 10;
    
    .legend-item {
      display: flex;
      align-items: center;
      gap: 4px;
      
      .legend-line {
        display: inline-block;
        width: 20px;
        border-top-width: 1px;
        border-top-style: solid;
      }
    }
  }
}
</style>
